module.exports = __webpack_public_path__ + "static/media/testivelogo.e226318b.svg";